(async () => {
    if (!customElements.get("featured-collection-swiper")) {
        class FeaturedCollection extends HTMLElement {
            constructor() {
                super();
                this.swiperElement = this.querySelector("[data-swiper-featured-collection]");
                this.swiperOptions = {
                    loop: false,
                    autoplay: false,
                    slidesPerView: 4.5,
                    direction: "horizontal",
                    observer: false,
                    resizeEvent: "auto",
                    breakpoints: {
                        320: {
                            slidesPerView: 1.5,
                            spaceBetween: 15
                        },
                        768: {
                            slidesPerView: 2.5,
                            spaceBetween: 20
                        },
                        1024: {
                            slidesPerView: 3.5,
                            spaceBetween: 20
                        },
                        1440: {
                            slidesPerView: 4.5,
                            spaceBetween: 20
                        },
                        1920: {
                            slidesPerView: 5.5,
                            spaceBetween: 20
                        },
                        3200: {
                            slidesPerView: 7.5,
                            spaceBetween: 20
                        }
                    }
                };
                if (this && this.dataset && this.dataset.options) {
                    const jsonOptions = JSON.parse(this.dataset.options);
                    if (jsonOptions) {
                        this.swiperOptions = {
                            ...this.swiperOptions,
                            ...jsonOptions
                        }
                    }
                }
                if (Shopify.designMode && this.swiperInstance) {
                    window.addEventListener("shopify:section:load", (() => {
                        this.swiperInstance.update()
                    }))
                }
                this.init()
            }
            init() {
                this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions)
            }
        }
        window.FeaturedCollection = FeaturedCollection;
        customElements.define("featured-collection-swiper", FeaturedCollection)
    }
})();
//# sourceMappingURL=featured-collection.js.map